import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/jquery.fittext.js'
import '../../assets/scripts/jquery.lettering.js'
import '../../assets/scripts/jquery.textillate.js'

$(document).ready(function(){
  $('.ny-banner h1').textillate();
  if($('.ny-banner h2').html() != ''){
    setTimeout(function(){
      $('.ny-banner h2').textillate();
    },800)
  }

  var swiper1 = new Swiper(".section1 .mySwiper", {
    effect: "coverflow",
    grabCursor: true,
    initialSlide: 1,
    centeredSlides: true,
    slidesPerView: 1.5,
    coverflowEffect: {
      rotate: 0,
      stretch: '10%',
      depth: 300,
      modifier: 1.5,
      slideShadows: false,
    },
    navigation: {//按钮
      nextEl: ".section1 .swiper-button-next",
      prevEl: ".section1 .swiper-button-prev",
    },
  });

  var swiper2 = new Swiper(".section2 .mySwiper", {
    slidesPerView: 2,
    slidesPerGroup : 2,
    grid: {
      fill: 'column',
      rows: 2,
    },
    pagination: {// 分页
      el: ".section2 .swiper-pagination",
      clickable: true,
    },
    breakpoints: { //响应式
      768: {  //当屏幕宽度大于等于768 
        slidesPerView: 3,
        slidesPerGroup : 3,
      },
      1024: {  //当屏幕宽度大于等于768 
        slidesPerView: 4,
        slidesPerGroup : 4,
      },
      1280: {  //当屏幕宽度大于等于1280
        slidesPerView: 5,
        slidesPerGroup : 5,
      }
    },
  });
})